export const homeImageCtaCardConfig = {
    imageUrl: "/images/cta-card/image-cta.jpg",
    heading: "Find the ED Solutions You Need",
    description: "Join our community of success stories and embark on your journey to renewed vitality and confidence.",
    buttonText: {
        text: "Get Started"
    }
};
export const aboutUsImageCtaCardConfig = {
    imageUrl: "/images/cta-card/image-cta-7.jpg",
    heading: "Find the ED Solutions You Need",
    description: "Join our community of success stories and embark on your journey to renewed vitality and confidence.",
    buttonText: {
        text: "Get Started"
    }
};
export const trimixImageCtaCardConfig = {
    imageUrl: "/images/cta-card/f8ed9b665482372d5c763d0a5f4baf7b-mirror.jpg",
    heading: "Explore Oral ED Medications",
    description: "Access dependable oral meds like Sildenafil (same ingredient as Viagra®) and Tadalafil (same ingredient as Cialis®).",
    buttonText: {
        text: "Learn More",
        afterUpdateProfileText: "Learn More",
        to: "https://dev.defyed.com/oral-meds"
    }
};
export const trimixMidImageCtaCardConfig = {
    imageUrl: "/images/cta-card/f8ed9b665482372d5c763d0a5f4baf7b-mirror.jpg",
    heading: "Subscribe Today",
    description: "Subscribe today for consistent savings, hassle-free refills, and uninterrupted access to the ED medications you trust.",
    buttonText: {
        text: "Get Started"
    },
    midCta: true,
    className: "!mb-0 !min-h-[705px] !rounded-b-[5rem]"
};
export const oralMedImageCtaCardConfig = {
    imageUrl: "/images/cta-card/image-cta-3.jpg",
    heading: "Explore Injectable ED Medications",
    description: "Explore our injectable options for a fast-acting, highly effective solution tailored to your needs.",
    buttonText: {
        text: "Learn More",
        afterUpdateProfileText: "Learn More",
        to: "https://www.defymedical.com/services/erectile-disfunction/?_gl=1*1g27w2d*_up*MQ..*_ga*MTE1ODAzMzY4MS4xNzUxOTgxNTgx*_ga_XWPYJFFXE5*czE3NTE5ODE1ODAkbzEkZzEkdDE3NTE5ODE1ODYkajU0JGwwJGgw"
    }
};
export const oralMedMidImageCtaCardConfig = {
    imageUrl: "/images/cta-card/af332c68226104b6f8c9b12c914d74e1.jpg",
    heading: "Subscribe Today",
    description: "Subscribe today for consistent savings, hassle-free refills, and uninterrupted access to the ED medications you trust.",
    buttonText: {
        text: "Get Started"
    },
    midCta: true,
    className: "!mb-0 !min-h-[705px] !rounded-b-[5rem]"
};
export const contactUsImageCtaCardConfig = {
    imageUrl: "/images/8e4492942a20306a60114465b5d354e8.jpg",
    heading: "Subscribe Today",
    description:
        "Subscribe today for consistent savings, hassle-free refills, and uninterrupted access to the ED medications you trust.",
    buttonText: {
        text: "Get Started"
    },
    className: "!pb-[13.375rem]"
};

export const productDetailImageCtaCardConfig = {
    imageUrl: "/images/image-cta-8.jpg",
    heading: "Explore Injectable ED Medications",
    description: "Explore our injectable options for a fast-acting, highly effective solution tailored to your needs.",
    buttonText: {
        text: "Learn More",
        afterUpdateProfileText: "Learn More",
        to: "https://www.defymedical.com/services/erectile-disfunction/?_gl=1*1g27w2d*_up*MQ..*_ga*MTE1ODAzMzY4MS4xNzUxOTgxNTgx*_ga_XWPYJFFXE5*czE3NTE5ODE1ODAkbzEkZzEkdDE3NTE5ODE1ODYkajU0JGwwJGgw",
    },
    className: "bg-center"
};